module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('v-container', {
    staticClass: "px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "dflex footer-sitemap white--text"
  }, [_c('div', {
    staticClass: "sitemap-link pa-3"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v(" Help center ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sitemap-link pa-3"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v(" Terms & Privacy ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sitemap-link pa-3"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v(" Report a bug ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dflex justify-space-between copyright-footer"
  }, [_c('p', {
    staticClass: "pa-3"
  }, [_vm._v("©YouSound, Inc..")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce2ef73","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landingPages/Footer-2.vue
// module id = 1667
// module chunks = 180